<template>
    <div class="about" style="padding: 20px">
        <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:divider>
                <v-icon>mdi-forward</v-icon>
            </template>
        </v-breadcrumbs>
        <v-form
                ref="form"
                v-model="valid"
        >
            <v-card
                    :loading="loading"
            >
                <v-card-title>
                    Create User
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col
                                cols="12"
                                md="6"
                                sm="6"
                                xs="12"

                        >
                            <v-text-field
                                    v-model="dados.name"
                                    :counter="200"
                                    maxlength="200"
                                    :rules="nameRules"
                                    label="Name"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"
                                sm="6"
                                xs="12"

                        >
                            <v-text-field
                                    v-model="dados.user"
                                    :counter="200"
                                    maxlength="200"
                                    :rules="nameRules"
                                    label="User"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"
                                sm="6"
                                xs="12"

                        >
                            <v-text-field
                                    v-model="dados.password"
                                    :counter="200"
                                    maxlength="200"
                                    label="Password"
                                    :rules="nameRules"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"
                                sm="6"
                                xs="12"

                        >
                            <v-switch v-model="dados.status" class="ma-4" label="Active"></v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <br>
            <div v-if="erro">
                <v-alert type="error" dense outlined v-for="(item,index) in msg" :key="index">
                    {{ item }}
                </v-alert>
            </div>
            <div v-else>
                <v-alert type="success" dense outlined v-for="(item,index) in msg" :key="index">
                    {{ item }}
                </v-alert>
            </div>
            <v-btn
                    v-if="loading == false"
                    :disabled="!valid"
                    color="success"
                    class="mr-4"
                    @click="validate"
            >
                Save
            </v-btn>
        </v-form>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                valid:true,
                loading:false,
                erro:true,
                msg:[],
                nameRules: [
                    v => !!v || 'Name is required',
                    v => (v && v.length <= 200) || 'Name must be less than 10 characters',
                ],
                userRules: [
                    v => !!v || 'User is required',
                    v => (v && v.length <= 200) || 'User must be less than 10 characters',
                ],
                passwordRules: [
                    v => !!v || 'Password is required',
                    v => (v && v.length <= 200) || 'Password must be less than 10 characters',
                ],
                dados:{
                    name:"",
                    user:"",
                    password:"",
                    status:1,
                },
                breadcrumbs: [
                    {
                        text: 'Dashboard',
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Users',
                        disabled: false,
                        to: '/users',
                    },
                    {
                        text: 'Create User',
                        disabled: true,
                        to: '/house',
                    },
                ]
            }
        },
        methods: {
            validate () {
                if (this.$refs.form.validate()) {
                    this.snackbar = true

                    this.erro = false;
                    this.loading = true;
                    this.msg = [];

                    var arr = JSON.stringify(this.dados);
                    this.$http.post("https://api.bestchoicevacation.com/users/create",arr,{
                        headers: {
                            'x-access-token': localStorage.hash
                        }
                    }).then(response => {
                        this.loading = false;
                        this.msg = response.data.msg;
                        if(response.data.erro == '1'){
                            this.erro = true;
                        }else{
                            this.$refs.form.reset();
                        }
                    });
                }
            }
        }
    }
</script>
